<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import home from '@/views/home.vue'
// import api from '@/api'

export default {
  name: 'App',
  components: {
    home
    // ,api
  }
}
</script>

<style lang="scss">

</style>
